import {Component, Input, OnInit} from '@angular/core';
import {ImageUtils} from '../utils/image/image-utils';
import {LanguageService} from '../../services/language/language.service';
import {QrCodeTypeEnum} from '../../enums/streaming-bundles/qr-code-type.enum';

@Component({
  selector: 'app-qr-tile',
  templateUrl: './qr-tile.component.html',
  styleUrls: ['./qr-tile.component.less']
})
export class QrTileComponent implements OnInit {
  @Input() title;
  @Input() description;
  @Input() QRCodeType: QrCodeTypeEnum;

  constructor(private languageService: LanguageService) {
  }

  ngOnInit() {
  }

  public get QRCodeImgUrl(): string {
    const language = this.languageService.getCurrentLanguage().toLowerCase();
    return ImageUtils.getQrCodeImageUrl(this.QRCodeType, language);
  }
}
